import { createAdminEditIdempotencyKey } from './adminEditIdempotencyKey';

export function editDonationHeaders(token: string) {
  return {
    accept: '*/*',
    'content-type': 'application/json',
    Authorization: token,
    'Idempotency-Key': createAdminEditIdempotencyKey(),
  };
}
